export {default as CharacterDetailAttribute} from './CharacterDetailAttribute';
export {default as CharacterDetailList} from './CharacterDetailList';
export {default as CharacterDetailPage} from './CharacterDetailPage';
export {default as CharacterDetailLessonPlans} from './CharacterDetailLessonPlans';
export {default as CharacterDetailRequiredLessons} from './CharacterDetailRequiredLessons';
export {default as CharacterDetailSupplements} from './CharacterDetailSupplements';



// WEBPACK FOOTER //
// ./app/features/characterDetail/components/index.js